"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourcePage = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var classNames = require("classnames");
var Bigpopup_1 = require("@/pages/common/components/Bigpopup");
var Message_1 = require("@/pages/common/components/Message");
var MegaMenu_1 = require("@/pages/common/components/MegaMenu");
var Megafoot_1 = require("@/pages/common/components/Megafoot");
var Login_1 = require("@/pages/common/components/Login");
var mapStateToProps = function (state, ownProps) {
    var headProps = {};
    if (ownProps.headStyle && ownProps.title) {
        headProps = __assign(__assign({}, headProps), { headStyle: ownProps.headStyle, title: ownProps.title });
    }
    if (ownProps.customHead) {
        headProps = __assign(__assign({}, headProps), { customHead: ownProps.customHead });
    }
    return __assign(__assign(__assign(__assign({}, state), { children: ownProps.children }), headProps), { menu: ownProps.menu, currentPage: ownProps.currentPage });
};
var mapDispatchToProps = function () { return ({}); };
exports.resourcePage = function (props) {
    var renderMenuItem = function (it, i, props) {
        var classes = classNames([
            'c-accordian', {
                'c-accordian--selected': it.page === props.currentPage,
            },
        ]);
        var renderChildren = function (it, props) {
            if (!it.children || it.children.length === 0)
                return;
            var renderChildrenItem = function (it, i, props) {
                var childClassname = classNames([
                    'c-accordian__item', {
                        'c-accordian__item--active': it.page === props.currentPage,
                    },
                ]);
                return (React.createElement("a", { key: i, href: it.link, className: childClassname }, it.name));
            };
            return (React.createElement("div", { className: "c-accordian__body" }, it.children.map(function (it, i) { return renderChildrenItem(it, i, props); })));
        };
        return (React.createElement("div", { key: i, className: classes },
            React.createElement("a", { href: it.link, className: "c-accordian__head" },
                React.createElement("span", { className: "c-accordian__icon c-accordian__dot" }),
                React.createElement("span", { className: "c-accordian__text" }, it.name)),
            renderChildren(it, props)));
    };
    var renderGuideMenuItem = function (it, i, props) {
        var classes = classNames([
            'c-accordian',
        ]);
        var renderChildren = function (it, props) {
            if (!it.subItems || it.subItems.length === 0)
                return;
            var renderChildrenItem = function (it, i) {
                var childClassname = classNames([
                    'c-accordian__item', {
                        'c-accordian__item--active': it.current,
                    },
                ]);
                return (React.createElement("a", { key: i, href: it.url, className: childClassname }, it.name));
            };
            return (React.createElement("div", { className: "c-accordian__body", style: { maxHeight: 'unset' } }, it.subItems.map(function (it, i) { return renderChildrenItem(it, i); })));
        };
        return (React.createElement("div", { key: i, className: classes },
            React.createElement("a", { className: "c-accordian__head", href: it['url'] },
                React.createElement("span", { className: "c-accordian__icon" }),
                React.createElement("span", { className: "c-accordian__text" }, it.name)),
            renderChildren(it, props)));
    };
    var renderHead = function (props) {
        if (props.customHead)
            return props.customHead;
        return (React.createElement("div", { className: "c-bighead", style: props.headStyle },
            React.createElement("h1", { className: "c-bighead__title" }, props.title)));
    };
    var pageClass = classNames([
        {
            'c-nav--safari': true,
            'c-nav__menu-main--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.TOPMENU,
            'c-nav__menu-setting--mobile-active': props.layout.activePanel === LayoutState_1.ActivePanel.CONFIG,
        },
    ]);
    var renderMenuItems = function () {
        if (props.guideMenuItems) {
            return null;
        }
        return (props.menu.children.map(function (it, i) { return renderMenuItem(it, i, props); }));
    };
    var renderGuideMenuItems = function () {
        if (props.guideMenuItems) {
            return (props.guideMenuItems.map(function (it, i) { return renderGuideMenuItem(it, i, props); }));
        }
        return null;
    };
    var renderMenuTitle = function () {
        if (props.guideMenuItems) {
            return (React.createElement("div", { style: { height: 30 } }));
        }
        return (React.createElement("div", { className: "c-accordian__title" },
            React.createElement("span", { className: "c-accordian__icon" }),
            React.createElement("span", { className: "c-accordian__text" }, props.menu.name)));
    };
    return (React.createElement("div", { id: "resource-page", className: pageClass },
        React.createElement(Bigpopup_1.default, null),
        React.createElement(Message_1.default, null),
        React.createElement(MegaMenu_1.default, { nobottom: true }),
        renderHead(props),
        React.createElement("div", { className: "l-container l-container--r48  l-container--hide-mobile l-container--alignleft" },
            React.createElement("div", { className: "l-container__side" },
                renderMenuTitle(),
                renderMenuItems(),
                renderGuideMenuItems()),
            React.createElement("div", { className: "l-container__main", style: { maxWidth: 'none' } },
                props.children,
                React.createElement("div", { className: "l-container__mfull" },
                    React.createElement(Megafoot_1.default, null),
                    React.createElement(Login_1.default, null))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.resourcePage);
